










































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateEquipment from "./create-equipment.vue";
import EditEquipment from './edit-equipment.vue';
let ispartysrc= require("@/images/danghui.png");

class PageBHUserRequest extends PageRequest {
  Keyword: string;
  isrent: number; //nullable
  stime: Date;
  etime: Date;
}
@Component({
        components:{CreateEquipment,EditEquipment}
    })
 
 
export default class Goods extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
                   
    return this.$store.state.equipment.list;
  }
  get loading() {
    return this.$store.state.equipment.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("equipment/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("equipment/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }

    await this.$store.dispatch({
      type: "equipment/getAll",
      data: this.pagerequest,
    });
  }
  
 

  get pageSize() {
    return this.$store.state.equipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.equipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.equipment.currentPage;
  }
   
 
  columns = [
     {
      
      title: this.L("ID"),
      key: "id",
    },
     {
      
      
       title: this.L("设备类型"),
       render: (h: any, params: any) => {
      
        let borGtxt="";
         if(params.row.equipmentType==1){
            borGtxt="电子秤";
         }
          if(params.row.borG==2){
            borGtxt="发袋机";
         }
         


        return h("span", borGtxt);
      },
    },
     {
      
      title: this.L("点位名称"),
      key: "name",
    },
     {
      
      title: this.L("设备编号"),
      key: "equipmentNumber",
       
    }
      
    ,
     {
      
      
       title: this.L("所属小区"),
       render: (h: any, params: any) => {
      
 
        return h("span", params.row.vArea.vilname);
      },
    },
     
   
     
     
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("equipment/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteUserConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "equipment/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.getAreaAll()
  }

  async getAreaAll() {
    await this.$store.dispatch({
      type: "equipment/getQAreaAllData",
    });
  }

  //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "equipment/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				
					lt.map((item) => { // 这里修改要下载的字段内容
					  item.isstop == false ? item.isstop = '否' : item.isstop == true ?  item.isstop ='是' : item.isstop ='否'
         
          item.goodsTypename='';
           if(item.bHgoodsType!=null){
               item.goodsTypename = item.bHgoodsType.goodsTypename
           }

         let borGtxt="";
         if(item.borG==0){
            borGtxt="蓝、绿积分";
         }
          if(item.borG==1){
            borGtxt="蓝积分";
         }
          if(item.borG==2){
            borGtxt="绿积分";
         }
 item.borGtxt=borGtxt;


            item.addtime=new Date(item.addtime).toLocaleString()
					  return item;
					});
    
					const filterVal = ['id', 'goodsname','goodsTypename','goodsimg','goodsprice' , 'borGtxt', 'goodskc', 'equipid'];// 取出要下载的表头字段
					const tHeader = ['编号','物品名称','物品分类','图片','兑换分值','积分兑换类型','物品剩余数量','设备ID'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '物品管理');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

   
			
}
